import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { GetProfessionalsArgs } from "../schemas";

const getProfessionalsQueryKey = (args: GetProfessionalsArgs) =>
  ["getProfessionals", args.health_care_organization_id, args.params] as const;

export const useGetProfessionals = (args: GetProfessionalsArgs) => {
  const client = useApiClient();

  return useQuery(getProfessionalsQueryKey(args), () => client.getProfessionals(args));
};
